import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FJActionVideoRemoveBg from '../../../../redux/action/FJActionVideoRemoveBg';
import FJVideoRemoveBgRemoverAfter from '../view/FJVideoRemoveBgRemoverAfter';
import FJEvent from '../../../../store/FJEvent';
import { FJ_EVENT_TYPE } from '../../../../constants/FJEvenTypeConstant';
import FJConstant from '../../../../constants/FJConstant';
import PropTypes from 'prop-types';
const FJVideoRemoveBgCustomRemoverAfterContainer = ({ isShow }) => {
    const dispatch = useDispatch();
    const isTrimVideo = useSelector(state => state.videoBgRemover.customRemoverIsTrimVideo);
    const customRemoverStatus = useSelector(state => state.videoBgRemover.customRemoverStatus);

    const goToBack = useCallback(() => {
        FJEvent.dispatch(FJ_EVENT_TYPE.HIDE_SIDE_MODAL);
        dispatch(FJActionVideoRemoveBg.goBackCustomRemoverAction());
    }, [dispatch]);

    const _exportVideo = useCallback(() => {
        FJEvent.dispatch(FJ_EVENT_TYPE.HIDE_SIDE_MODAL);
        dispatch(FJActionVideoRemoveBg.exportVideoAction());
    }, [dispatch]);

    const _removeAll = useCallback(() => {
        FJEvent.dispatch(FJ_EVENT_TYPE.HIDE_SIDE_MODAL);
        dispatch(FJActionVideoRemoveBg.removeAllAction());
    }, [dispatch]);

    return (
        <FJVideoRemoveBgRemoverAfter
            isShow={isShow}
            goToBack={goToBack}
            exportVideo={_exportVideo}
            removeAll={_removeAll}
            isTrimVideo={isTrimVideo}
            disabled={customRemoverStatus === FJConstant.LOADING}
            sourceLoadingError={customRemoverStatus === FJConstant.SOURCE_LOADING_ERROR}
        />
    );
};

FJVideoRemoveBgCustomRemoverAfterContainer.propTypes = {
    isShow: PropTypes.bool,
};

export default FJVideoRemoveBgCustomRemoverAfterContainer;
